import React, { useEffect, useState } from 'react'

import { ERRORS } from 'consts'
import { useApiCall } from 'hooks'
import { snackbar } from 'components'

import { ReviewsFilters } from '../api'
import { getReviewStats } from './api'
import { ReviewKpiCard } from './ReviewKpiCard'
import { StarDistribution } from './StarDistribution'
import { GetReviewStatsResponse, ReviewStats } from './types'
import { formatDashboardNumber } from '../../NewDashboard/utils/formatDashboardNumber'

interface ReviewIndicatorsPanelProps {
  appliedFilters: ReviewsFilters
  refreshTrigger: number
}

export const ReviewIndicatorsPanel: React.FC<ReviewIndicatorsPanelProps> = ({
  appliedFilters,
  refreshTrigger,
}) => {
  const [stats, setStats] = useState<ReviewStats | null>(null)
  const [fetchStats, isLoading] = useApiCall<ReviewsFilters, GetReviewStatsResponse>(getReviewStats)

  useEffect(() => {
    if (refreshTrigger === 0) return

    fetchStats(appliedFilters)
      .then(response => setStats(response.stats ?? null))
      .catch(() => snackbar.show(ERRORS.GENERIC_ERROR_MESSAGE))
  }, [appliedFilters, refreshTrigger, fetchStats])

  const averageDisplay =
    stats && stats.totalCount > 0 ? `${stats.averageRating.toFixed(1)} / 5` : '— / 5'

  return (
    <div className="mb-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        <ReviewKpiCard title="Puntaje Promedio" value={averageDisplay} isLoading={isLoading} />
        <ReviewKpiCard
          title="Cantidad Total de Reseñas"
          value={stats ? formatDashboardNumber(stats.totalCount) : '0'}
          subtitle="reseñas"
          isLoading={isLoading}
        />
        <ReviewKpiCard
          title="Cantidad de Reseñas Negativas"
          value={stats ? formatDashboardNumber(stats.negativeCount) : '0'}
          subtitle="1 a 3 estrellas"
          isLoading={isLoading}
        />
      </div>
      <StarDistribution stats={stats} isLoading={isLoading} />
    </div>
  )
}
